import { Component, OnInit } from '@angular/core';
import {Title } from "@angular/platform-browser";

//jquery declaration
declare var $: any;

@Component({
  selector: 'app-ourcompany',
  templateUrl: './ourcompany.component.html',
  styleUrls: ['./ourcompany.component.css']
})
export class OurcompanyComponent implements OnInit {

  constructor(
    private titleService: Title,
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle("Our Company - SFI Compliance, Inc");
    this.topposition();
  }

  //scroll to top of the page automatically
  topposition() {

 
    $('html, body').animate({
      scrollTop: 0
    }, 1000, 'easeInOutExpo');

    return false;
}

}
